import React, { useEffect, useRef, useState } from 'react';
import { RadialGauge } from 'canvas-gauges';
import Panel from "../components/Panel";

// Source link
// https://canvas-gauges.com/documentation/examples/

const Barometer = ({data}) => {
  const gaugeRef = useRef(null);
  const [gauge, createGauge] = useState({});

  useEffect(() => {
    const newGauge = new RadialGauge({
      renderTo: gaugeRef.current,
      title: "Barometer",
      units: "hPa",
      minValue: 950,
      maxValue: 1060,
      majorTicks: [
        "950",
        "960",
        "970",
        "980",
        "990",
        "1000",
        "1010",
        "1020",
        "1030",
        "1040",
        "1050",
        "1060",
      ],
      minorTicks: 10,
      strokeTicks: true,
      highlights: [
        { from: 217, to: 250, color: 'rgba(0,0,255,.25)' },
        { from: 250, to: 290, color: 'rgba(12, 166, 12, 0.15)' },
        { from: 290, to: 327, color: 'rgba(239, 132, 25, 0.15)' },
      ],
      colorPlate: "#ddd",
      borderShadowWidth: 0,
      borders: false,
      needleType: "arrow",
      needleWidth: 2,
      needleCircleSize: 7,
      needleCircleOuter: true,
      needleCircleInner: true,
      animationDuration: 1500,
      animationRule: "linear",
      valueBox: false,
      value: data?.hpa
    });

    newGauge.draw();

    createGauge(newGauge)
  }, []);

  gauge.value = data?.hpa
  return (
    <Panel>
      <canvas ref={gaugeRef} style={{padding: 10, width: '100%', height: '100%'}} />
    </Panel>
  );
};

export default Barometer;